import ConnectedIcon from 'assets/ConnectedIcon';
import { BaseTag } from '../../components';
import { TagIntent } from '../../styles';
import DisconnectedIcon from 'assets/DisconnectedIcon';
import SignalIcon from 'assets/SignalIcon';
import RoundedWarningIcon from 'assets/RoundedWarningIcon';

export const SucceededTag = () => (
  <BaseTag
    icon={ConnectedIcon}
    translationId="views.FleetSettings.OEMTelematics.Status.succeeded"
    intent={TagIntent.ACTIVE}
  />
);

export const PartiallySucceededTag = () => (
  <BaseTag
    icon={RoundedWarningIcon}
    translationId="views.FleetSettings.OEMTelematics.Status.partiallySucceeded"
    intent={TagIntent.WARNING}
  />
);

export const InQueueTag = () => (
  <BaseTag
    icon={SignalIcon}
    translationId="views.FleetSettings.OEMTelematics.Status.inQueue"
    intent={TagIntent.UNKNOWN}
  />
);

export const UnEnrollmentPendingTag = () => (
  <BaseTag
    icon={ConnectedIcon}
    translationId="views.FleetSettings.OEMTelematics.Status.unenrollmentPending"
    intent={TagIntent.WARNING}
  />
);

export const FailedTag = () => (
  <BaseTag
    icon={DisconnectedIcon}
    translationId="views.FleetSettings.OEMTelematics.Status.failed"
    intent={TagIntent.DANGER}
  />
);
